import { render, staticRenderFns } from "./TipoSala.vue?vue&type=template&id=24d84bda&"
import script from "./TipoSala.vue?vue&type=script&lang=js&"
export * from "./TipoSala.vue?vue&type=script&lang=js&"
import style0 from "./TipoSala.vue?vue&type=style&index=0&id=24d84bda&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports